import { render } from "./who_to_follow_panel.vue?vue&type=template&id=f150b2ba"
import script from "./who_to_follow_panel.js?vue&type=script&lang=js"
export * from "./who_to_follow_panel.js?vue&type=script&lang=js"

import "./who_to_follow_panel.vue?vue&type=style&index=0&id=f150b2ba&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__